import { Box, styled, Link } from "@material-ui/core";
import { Colors, Typography } from "../../shared/theme/styles.enum";

export const TermsAndConditionsContainer = styled(Box)(({ theme }) => ({
  fontFamily: Typography.Captions,
  backgroundColor: Colors.Black,
  textAlign: "center",
  width: "100vw",
  color: Colors.White,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  cursor: "pointer",
}));

export const TermsAndConditionsLink = styled(Link)(({ theme }) => ({
  color: Colors.Teal,
}));
